import { render, staticRenderFns } from "./ParentName.vue?vue&type=template&id=9e45c862"
import script from "./ParentName.vue?vue&type=script&lang=ts"
export * from "./ParentName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports